import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CompanyName as SchemaCompanyName } from '../schemas/CompanyName';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const GetCompanyNameContentType = '' as const;
export type GetCompanyNameRequest = void;
export type GetCompanyNameResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful get company name
     */
    '200': {
        'application/json': SchemaCompanyName;
    };
};
export type GetCompanyNameResponseSuccess = GetCompanyNameResponses['200']['application/json'];
export type GetCompanyNameSearchParams = undefined;
export type GetCompanyNamePathParameters = undefined;
export const GetCompanyNameUrl = '/company/name' as const;
export const GetCompanyNameMethod = 'GET' as const;
export const getGetCompanyNameUrl = (_params?: GetCompanyNamePathParameters) => GetCompanyNameUrl;
